<div id="wrapper">
    <div class="allcont">
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
        <div>
            <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event"
                (updateSelectBan)="this.selectBan=$event" (updateInitializeData)="this.initializeData()">
            </app-tab-nav>
        </div>
        <div class="basicrow">
            <div class="container">
                <div class="fulltitle m-top-i f-btitle autodef">
                    <span class="icon-dash-13"></span> Soporte
                </div>
            </div>
            <div class="basicrow roboto-r f-reg f-black m-top m-bott">
                <div class="container padding-bottom">
                    <div class="basicrow bg-gray mbott m-top-i padding-info" id="last-div">
                        <div>
                            <div class="basicrow m-top-i mbott">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
                                        <div class="basicrow f-title f-black">
                                            Servicio al Cliente
                                        </div>
                                        <div class="basicrow f-big roboto-l f-black m-top">
                                            Cont&aacute;ctanos
                                        </div>
                                        <div class="basicrow f-reg roboto-r f-black m-top-i">
                                            <div class="row">
                                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div class="basicrow f-bmed roboto-b">
                                                        Horario de Servicio al Cliente
                                                    </div>
                                                    <div class="basicrow m-top-ii">
                                                        <span class="roboto-b">Lunes a Viernes:</span> 8:00 a.m - 7:00 p.m
                                                        <br /><br />

                                                        <span class="roboto-b">S&aacute;bados y Domingos:</span> 8:00 a.m - 5:00 p.m<br /><br />

                                                        <span class="roboto-b">D&iacute;as Feriados:</span> 8:00 a.m - 5:00 p.m
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 h-mtop-i">
                                                    <div class="basicrow f-bmed roboto-b">
                                                        Tel&eacute;fonos de Contacto
                                                    </div>
                                                    <div class="basicrow m-top-ii">
                                                        <span class="roboto-b">Servicio al Cliente:</span> 787-775-0000.
                                                        <br /><br /> &oacute; marcando <span class="roboto-b">&#42;611</span> desde tu tel&eacute;fono celular.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-5">
                                        <div class="access-side">
                                            <div class="basicrow f-big roboto-l f-black">
                                                Accesos R&aacute;pidos
                                            </div>
                                            <div class="basicrow m-top-ii">
                                                <div class="basicrow m-top-ii">
                                                    <a routerLink="/frequentquestions" class="linkdefs f-med">
                                                        Preguntas Frecuentes&nbsp;&nbsp;
                                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
